import { useState } from "react";

import { faLightbulbOn } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styled, { useTheme } from "styled-components";

import { Body } from "shared/atoms/PatientApp";

interface Props {
  tip_description: string;
}

export const QuestionTip: React.FC<Props> = ({ tip_description }) => {
  const theme = useTheme();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <IconContainer onClick={() => setIsOpen(prevState => !prevState)}>
        <FontAwesomeIcon icon={faLightbulbOn} color={theme.colors.redesign.y100} style={{ fontSize: "16px" }} />
      </IconContainer>
      {isOpen && <Body>{tip_description}</Body>}
    </>
  );
};

const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  width: 40px;
  margin-left: auto;
  background: ${({ theme }) => theme.colors.redesign.y20};
  border-radius: 50%;
  cursor: pointer;
`;
